import { Component, ElementRef, inject, ViewChild, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '@cadriciel/core';
import { AppMenuItem } from '../models/app-menu.item';
import { ActiveRoleService } from '@shared/auth/active-role.service';

@Component({
    selector: '[app-menu]',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<div class="layout-menu-container" #menuContainer>
        <ul class="layout-menu">
            <ng-container *ngFor="let item of model(); let i = index">
                <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
                <li *ngIf="item.separator" class="menu-separator"></li>
            </ng-container>
        </ul>
    </div>`
})
export class AppMenu {
    el: ElementRef = inject(ElementRef);
    private menuService = inject(MenuService);
    private activeRoleService = inject(ActiveRoleService);

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    /**
     * Menu filtré selon le rôle actif (réactif au switch de rôle).
     * Un item sans `roles` est toujours visible ; un groupe vidé de ses enfants
     * est masqué.
     */
    model = computed<AppMenuItem[]>(() =>
        this.filterByRole(this.menuService.getMenu(), this.activeRoleService.activeRole())
    );

    private filterByRole(items: AppMenuItem[], role: string | null): AppMenuItem[] {
        const result: AppMenuItem[] = [];
        for (const item of items) {
            if (!this.isAllowed(item, role)) continue;
            if (item.items && item.items.length > 0) {
                const children = this.filterByRole(item.items, role);
                if (children.length > 0) {
                    result.push({ ...item, items: children });
                }
            } else {
                result.push(item);
            }
        }
        return result;
    }

    private isAllowed(item: AppMenuItem, role: string | null): boolean {
        if (!item.roles || item.roles.length === 0) return true;
        return !!role && item.roles.includes(role);
    }
}
